"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _OptionTypes = require("../types/OptionTypes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _partial = _interopRequireDefault(require("react-utils/partial"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _UIButtonGroup = _interopRequireDefault(require("../button/UIButtonGroup"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var UIViewController = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UIViewController, _PureComponent);

  function UIViewController() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIViewController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIViewController)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleChange = function (newValue, evt) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value;

      if (newValue === value) {
        return;
      }

      onChange((0, _SyntheticEvent.default)(newValue, evt));
    };

    return _this;
  }

  (0, _createClass2.default)(UIViewController, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          __onChange = _this$props2.onChange,
          options = _this$props2.options,
          size = _this$props2.size,
          value = _this$props2.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["onChange", "options", "size", "value"]);
      return _react.default.createElement(_UIButtonGroup.default, Object.assign({
        className: "private-button-select-group"
      }, rest, {
        role: "radiogroup"
      }), options.map(function (option) {
        var isActive = option.value === value;
        return _react.default.createElement(_UITooltip.default, {
          key: option.value,
          title: option.title
        }, _react.default.createElement(_UIButton.default, {
          active: isActive,
          "aria-checked": isActive,
          className: "private-button-select-group__option",
          disabled: option.disabled,
          onClick: (0, _partial.default)(_this2.handleChange, option.value),
          responsive: false,
          role: "radio",
          size: size,
          use: "tertiary-light"
        }, option.buttonText || option.text || option.value));
      }));
    }
  }]);
  return UIViewController;
}(_react.PureComponent);

UIViewController.propTypes = {
  onChange: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_OptionTypes.OptionType.isRequired).isRequired,
  size: _UIButton.default.propTypes.size,
  value: _propTypes.default.any
};
UIViewController.defaultProps = {
  size: 'small'
};
UIViewController.displayName = 'UIViewController';

var _default = (0, _Controllable.default)(UIViewController);

exports.default = _default;
module.exports = exports.default;